import checkRole from './checkRole';

export default function() {
    return checkRole.apply(this, [ACL.roles.TEACHER, ...arguments]);
}
